import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export function useZoneLabels(): {
  resolveLabel: (zoneCode: string) => string;
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery<{
    zones: Array<{ zoneCode: string; areaLabel: string }>;
  }>({
    queryKey: ["/api/zones"],
  });

  const labelMap = useMemo(() => {
    const map = new Map<string, string>();
    for (const z of data?.zones ?? []) {
      map.set(z.zoneCode, z.areaLabel);
    }
    return map;
  }, [data]);

  return {
    resolveLabel: (zoneCode: string) => labelMap.get(zoneCode) ?? zoneCode,
    isLoading,
  };
}
